import { useNavigate } from 'react-router-dom';
import { Card } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/shared/components/PageHeader';
import ReferralForm from '../components/ReferralForm';
import { useCreateReferral } from '../hooks/useReferralMutations';

export default function ReferralCreatePage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const mutation = useCreateReferral();
  const handleSubmit = (data: any) => { mutation.mutate(data, { onSuccess: () => navigate('/referrals') }); };
  return (
    <div>
      <PageHeader back title={t('referrals.addTitle')} subtitle={t('referrals.addSubtitle')} />
      <Card><ReferralForm onSubmit={handleSubmit} isLoading={mutation.isPending} /></Card>
    </div>
  );
}
